import React from 'react';


import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal'

interface IProps {
  onClose: () => void;
}

const VerifyHelp = (props: IProps) => {
  return (
    <HalfScreenInfoModal
      title="获取不到验证码"
      height="7.04rem"
      closeButtonText="关闭"
      onClose={ props.onClose }
    >
      <div styleName="user-logout-verify-help-content">
        <div styleName="title">
          无法获取短信验证码怎么办？
        </div>
        <div styleName="content">
          如果您的手机无法获取验证码，请您尝试以下方式：
        </div>
        <div styleName="content">
          1.请确保您的手机号码填写正确，本机未欠费或者停机
        </div>
        <div styleName="content">
          2.请确保当前手机通讯信号良好，可以接收短信
        </div>
        <div styleName="content">
          3.看看手机短信垃圾箱，找一下验证码短信是否在垃圾箱里
        </div>
        <div styleName="content">
          4.获取验证码也许会有时延，请耐心等待一下
        </div>
        <div styleName="content">
          5.如果验证码一直未收到，请与运营商客服确认是否将1069开头的号码拉入屏蔽黑名单，请与运营商解除
        </div>
      </div>
    </HalfScreenInfoModal>
  )
}

export default VerifyHelp;